import { Directive, HostListener, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appSsn]'
})
export class SsnDirective implements AfterViewInit {

  constructor(private ngControl: NgControl) {}

  ngAfterViewInit() {
    this.formatValue();
  }

  @HostListener('input')
  @HostListener('blur')
  onInputOrBlur() {
    this.formatValue();
  }

    private formatValue() {
    const control = this.ngControl.control;
    if (!control?.value) return;

    let digits = control.value.toString().replace(/\D/g, '');
    if (digits.length > 9) digits = digits.substring(0, 9);

    let formatted = digits;
    if (digits.length > 5) {
        formatted = `${digits.substring(0, 3)}-${digits.substring(3, 5)}-${digits.substring(5)}`;
    } else if (digits.length > 3) {
        formatted = `${digits.substring(0, 3)}-${digits.substring(3)}`;
    }

    if (control.value !== formatted) {
        control.setValue(formatted, { emitEvent: true });
    }

    control.markAsTouched();
    control.updateValueAndValidity();
    }
}